<template>
<div>
  <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@4.6.2/dist/css/bootstrap.min.css" integrity="sha384-xOolHFLEh07PJGoPkLv1IbcEPTNtaed2xpHsD9ESMhqIYd0nLMwNLD69Npy4HI+N" crossorigin="anonymous">
  <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">  
   
  <div class=" col-md-6 col-12 p-0">

    <div class="col-12 row mx-0 px-3 py-2" style="background-image: linear-gradient(rgb(0, 145, 165), rgb(1, 136, 154), rgb(2, 126, 144), rgb(3, 117, 133), rgb(3, 108, 123));color:#ffffff;">
      <h3><strong>{{msglist[$route.params.language][1]}}</strong></h3><!--KH滴定設定-->
      <div class="ml-auto"><router-link :to="{ name: 'my-kh', params: { language: $route.params.language }}">
              <button class="btn btn-primary" style="font-size: 15px; border-radius: 5px;">{{msglist[$route.params.language][0]}}</button><!--KH 設定-->
            </router-link></div>
    </div>
    
    
        

    <div v-if="serial.startsWith('KH2')" class="col-12 row mx-0 px-0 py-2 mb-1" style="background:  rgb(242, 242, 242);">
        <div class="col-12 px-0 row mx-0">
            <div class="col-auto align-self-center"><img style="width:55px;" src="data:image/png;base64,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"></div>
              <div class="col border-left align-self-center">
              <div class="col-12 px-0 font-weight-bold" style="font-size:1.2rem">{{msglist[$route.params.language][2]}}</div>  <!--校正溶液量-->
              <div class="col-12 px-0 row mx-0 align-self-center" style="width:160px">
                <input style="height:30px;font-size:1.2rem; font-weight: bold" v-model="CalRemain" maxlength="4" class="col form-control text-center" name="KHRemain" type="text"> 
                <span class="col-auto px-2 align-self-center">ml</span>
              </div>
              <div class="col-12 px-0 pb-0">{{msglist[$route.params.language][3]}}</div> <!--隨著滴定而減少，顯示剩餘量-->
            </div>
        </div>
		</div>   
    <div v-if="serial.startsWith('KH2')" class="col-12 row mx-0 px-0 py-2 mb-1" style="background: rgb(242, 242, 242);">
		  		<div class="col-12 px-0 row mx-0">
		  				<div class="col-auto align-self-center"><img style="width:55px;" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEGUlEQVR4nO2ZXYhVVRTHf0oppi+CTnObHkrHkAShRI3A3rKc8d2HhHp0sjDHDHpVH6SaStEoXxp6LVD8igInKPMbHzQ/qic1MCEtdfyc6siS/4bl4Z5zzzn3zL1HmD9s7r17r7X2/u+99t5r7QtjGMMYimIpsA8YBqI2l+saS29eEhsqMPgooazPsxKmcBt4F6jRftSAtRpTlHVlhiRsJKqG9zQ2c7OGuC7hTqqHTo3tWhbh4ItVRZR1fEWJPA0sBzYB3wJngEvATeAG8Kfq9gKfAq8BT1WFyEydIqeaOIV+AdYBM9pB5EXN7H9O/i6wX8RsZV4Cul17t+qWS2a/dEK72doFvNAKIjZrO5zM//q8CEwpYG+KdL2tCNguVy2dyDjgbXfLjwCDwDPAOdW9UqDjxWo7J1uDsh1u87fUdylEbNa+cfVD6jTgfdXvTLD3E/BjQttO6ZqNALP9g+vv69hqFyZyWL9vAWuA8TH56TqZLpMfV6RrNjzGq69b6vtQGUSO6rcdnR0JOguBBfl53NezUg8d6jPSGJLGl4i4oM3WCUemFbHX9FifnWVtdpudk6o/wujjqPo6WccLmj5+zeAx4GCK7gFt7vg+youD6qujHSGK4bc8YXZBRK0gsla6e3jIiUxVgGi39CweYiKGL6X/IaODoVYRmS/9v4BJGeSfBFa60H9YJYT8b0omwEKWVa1KrI7IxhsN7opNLrZKKxYZf5X3DiuDyOuycTzlgeNqbKAW1g8Aq1UGVOdTBdPpaSWRicoOI7mah7nKv2q7o1VJm+kasFmykXT7WkXE8IHs2ED9SoQZPg88F9N5DJinYt89ngcuODI9o03kEWAZ8L3sWDZpeMK503n9jmOe69++x9HlyPzT6KWnGSJzXUxm5TvXts25U3wlshJB9SFF/pxRIPKyyx9+1xFpM4iOz5E6rlaEiGGLy1RDH6UQ6XYPe58Aj8baV7rTqVYCkS631xI3ftREsZmqh71qt+OUEoiESNvkdpOAoiQsL5+QYPNXyXxEeUQGXOKVSqRMXJPN/gZy7+QgsqbRO3A7iEzWU1CkciPDy2NbiJxNca1nY0+up4A5GWwWcq2flcIWxZ6Ezb4o9tfeoFYnC8Jmt2fWzETSHtmyIOn4naxH7OEGkXKh4zf4c5nPPv5CtADQY7bcKw+2uguxXqhzH/skZPl3mfjChSgWABbFfBeifJYm2Cuh2/rPLpFxTtQU6EUK/BJDiwYr+4ds/A08TgOsb/KG92XIvaj3uFzkQoa7Ir4SgYTZWEJG9MrNQgzVTPE5dp8jc1dhTdqqd2lPBHcy3RVUBD3OzcJpZsfpx0pz+/X9QCzVNXd6lYphGrDRpbBpZUSHRRX/Mn/Adfp0aZ6WK1ux7xbZmhuVdeBUH/cAv69V+xjnvZQAAAAASUVORK5CYII="></div>
                	<div class="col border-left align-self-center">
				  			<div class="col-12 px-0 font-weight-bold" style="font-size:1.2rem">{{msglist[$route.params.language][4]}}</div>  <!--幾天校正一次 -->
				  				<div class="px-2 row align-self-center" style="width:180px">
                    <input  v-model="Calday" style="height:30px;font-size:1.2rem; font-weight: bold" maxlength="3" class="col form-control text-center" name="KH_specification" type="text">
                      <span class="col-auto px-2 align-self-center">{{msglist[$route.params.language][5]}}</span> <!--天 -->
                  </div>
                  <div class="col-12 px-0 pb-0">{{msglist[$route.params.language][9]}}</div>
                </div>
		  		</div>
		  </div>  
      
      <div class="col-12 row mx-0 px-0 py-2 mb-1" style="background: rgb(242, 242, 242);">
		  		<div class="col-12 px-0 row mx-0">
		  				<div class="col-auto align-self-center"><img style="width:55px;" src="data:image/png;base64,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"></div>
                <div class="col border-left align-self-center">
				  			<div class="col-12 px-0 font-weight-bold" style="font-size:1.2rem">{{msglist[$route.params.language][6]}}</div><!--校正溶液少於-->
				  				<div class="px-0 row mx-0 align-self-center" style="width:160px">
                    <input style="height:30px;font-size:1.2rem; font-weight: bold" v-model="mlspec" maxlength="3" class="col form-control text-center" name="mlspec" type="text">
                    <span class="col-auto px-2 align-self-center">ml</span>
                  </div>
                 <div class="col-12 px-0 pb-2">{{msglist[$route.params.language][7]}}</div>  <!--時通知-->
		  				</div>
		  		</div>
		  </div> 
        
        <div class="col-12 row mx-0 px-0 py-3 mb-1 justify-content-center" style="background: rgb(242, 242, 242);">
		  			<button v-if="name!=='khacra'" @click=apply name="KH_settings_button" :disabled="disabled" class="btn btn-primary" style="min-width: 150px;">{{msglist[$route.params.language][10]}}</button> <!--套用-->
        </div>
        
          	     	
    
</div></div>
</template>
<script>
//import Log from 'loglevel';
import has from 'lodash/has';
import {
	mapLang
} from "../routes.js";

const mlist = {
	'en': [
    'My KH',
    'Auto Calibration',
		'Calibration solution',
		'Use 20ml for each calibration. This shows solution remain volume',
    'Calibrate once per',
    'days',
		'Calibration solution less than',
    'E-mail notify',
    'Notify through E-mail',
    'Input "0" to stop auto calibration',
    'Apply',
    'Applied',
    'Error',
    'Solution less than',
    'KH of calibration solution:',],
  'vi': [
    'KH Của Tôi',
    'Tự động hiệu chỉnh',
		'Dung dịch hiệu chuẩn',
		'Sử dụng 20ml cho mỗi lần hiệu chuẩn. Điều này cho thấy khối lượng dung dịch vẫn còn',
    'Hiệu chỉnh một lần mỗi',
    'ngày',
		'Dung dịch hiệu chuẩn nhỏ hơn',
    'Email thông báo',
    'Thông báo qua E-mail',
    'Nhập "0" để dừng tự động hiệu chỉnh',
    'Áp dụng',
    'Đã Áp Dụng',
    'Lỗi',
    'Giải pháp ít hơn',
    'KH của dung dịch hiệu chuẩn:',],
  'ms': [
    'My KH',
    'Auto Calibration',
		'Calibration solution',
		'Use 20ml for each calibration. This shows solution remain volume',
    'Calibrate once per',
    'days',
		'Calibration solution less than',
    'E-mail notify',
    'Notify through E-mail',
    'Input "0" to stop auto calibration',
    'Apply',
    'Applied',
    'Error',
    'Solution less than',
    'KH of calibration solution:',],
	'tw': [
    '我的KH',
		'自動校正設定',
		'校正液',
		'每次使用20ml，此顯示剩餘量',
    '幾天校正一次',
    '天',
		'KH校正液&提升液少於',
    'E-mail通知',
    '發送E-mail通知',
    '輸入0可停止自動校正',
    '套用',
    '已套用',
    '錯誤',
    '少於幾 ml，E-mail通知',
    '校正液的KH:',],
	'cn': [
    '我的KH',
		'自动校准设定',
		'校准液',
		'每次使用20ml，此显示剩馀量',
    '几天校准一次',
    '天',
		'KH校准液&提升液少於',
    'E-mail通知 ',
    '发送E-mail通知',
    '输入0可停止自动校准',
    '套用',
    '已套用',
    '错误',
    '少于几 ml，E-mail通知',
    '校准液的KH:',],
}

//let PURL = process.env.SERVER;

function startCfg(Vue) {
    let PURL = localStorage.getItem("server") || process.env.SERVER;
    let url = PURL + '/api/v1/KH/start-config';
    let user = JSON.parse(localStorage.getItem("user")) || Vue.$store.getters.user || {};  
    let body = {
		"user": user.name,
        "serial": ''
    };
    let sidx=localStorage.getItem('sidx');  // restore sidx from localstorage after webpage reload or change language
    has(user, 'data.devices') ? body.serial = user.data.devices[sidx] : '';
    Vue.serial = body.serial;
    let product = Vue.serial.split('-')[0];
    
    if (Vue.KHdosing > 999) {Vue.KHdosing=999; } if (Vue.KHdosing < 10) {Vue.KHdosing=10; }
    if (Vue.maxKHdosingPerHr > 999) {Vue.maxKHdosingPerHr=999; } if (Vue.maxKHdosingPerHr < 0) {Vue.maxKHdosingPerHr=0; }
    body['field12'] = ""+ Number(Vue.CalRemain).toFixed(0);
    body['field16'] = ""+ Number(Vue.mlspec).toFixed(0);
    if (product === 'KH2') {if (Vue.Calday > 60) {Vue.Calday=60; } if (Vue.Calday < 0) {Vue.Calday=0; }
                            if (Vue.CalKH > 9.9) {Vue.CalKH=9.9; } if (Vue.CalKH < 1.0) {Vue.CalKH=1.0; } //KH2: KH value of calibration solution
                            body['field5'] = JSON.stringify(Number(Vue.KHdosing) * 1000 + Number(Vue.Calday)); //去除非數字字元
                            body['field6'] = JSON.stringify(Number(Vue.maxKHdosingPerHr) * 10000 + Number(Vue.CalKH)*1000);
                            if (Vue.KHdosing < 100) {body['field5'] = "0" + body['field5'];}  //每個位數不固定，可用此法，第一個位數不足要補"0"
                            if (Vue.KHdosing < 10) {body['field5'] = "0" + body['field5'];}
                            if (Vue.maxKHdosingPerHr < 100) {body['field6'] = "0" + body['field6'];}  //每個位數不固定，可用此法，第一個位數不足要補"0"
                            if (Vue.maxKHdosingPerHr < 10) {body['field6'] = "0" + body['field6'];}
                            if (Vue.maxKHdosingPerHr < 1) {body['field6'] = "0" + body['field6'];}  // allow this ==0
                            }  
                            
    /////// update parameters in localstorage ////////
    if (user.KHdosing) {
      Vue.$set(user.KHdosing, sidx, body['field5']);
      Vue.$set(user.maxKHdosingPerHr, sidx, body['field6']);
      Vue.$set(user.CalRemain, sidx, Math.round(body['field12']));
      Vue.$set(user.mlspec, sidx, Math.round(body['field16']));
      localStorage.setItem('user', JSON.stringify(user));
    }
    // asynch call
    let p1 = Vue.$http.post(url, body);
    Promise.all([p1]).then(([r1]) => {
        console.log("KH-calsolution -- parameters applied");
        Vue.setMsg(mlist[Vue.getLang()][13], 5);
    }, reason => {
      console.log('server error: ', reason);
        Vue.setMsg_logout(mlist[Vue.getLang()][14], 2);
    });
}

function fetchData(Vue) {

  let user = JSON.parse(localStorage.getItem("user")) || Vue.$store.getters.user || {};   
  let body = {
    "user": user.name,
    "password": ''
  };
  if (Vue.$route.params.sidx != null) {localStorage.setItem('sidx', Vue.$route.params.sidx);} // when reload webpage, sidx will be forget and = undefined, null
    let sidx=localStorage.getItem('sidx');  // restore sidx from localstorage after webpage reload
	  Vue.serial = user.data.devices[sidx]; // browser use
	  let product = Vue.serial.split('-')[0];
    Vue.name=user.name;
    if (user && user.KHdosing) { // if localstorage user && user.sleep exist, then restore Vue.u parameters from localstorage
      
        //////// get parameters from localstorage /////
        if (product ==='KH2') {user.KHdosing[sidx]=user.KHdosing[sidx].replace(/[^\d.-]/g, ''); //去除非數字字元
                              user.maxKHdosingPerHr[sidx]=user.maxKHdosingPerHr[sidx].replace(/[^\d.-]/g, ''); //去除非數字字元
                              Vue.KHdosing = Math.floor(user.KHdosing[sidx]/1000); 
                                   Vue.Calday = Math.floor(user.KHdosing[sidx]%1000);
                              Vue.maxKHdosingPerHr = Math.floor(user.maxKHdosingPerHr[sidx]/10000); 
                                   Vue.CalKH = user.maxKHdosingPerHr[sidx]%10000/1000;} // KH2: calibration solution KH value
        Vue.CalRemain = Math.round(user.CalRemain[sidx]); if (Vue.CalRemain < 0 || Vue.CalRemain == null) {Vue.CalRemain =0;}
        Vue.mlspec = Math.round(user.mlspec[sidx]);
        console.log("KH-calsolution -- get parameters from localstorage");
  } else {  
      let PURL = localStorage.getItem("server") || process.env.SERVER;
      let urls = PURL + '/api/v1/KH/' + Vue.serial + '/' + 'all_field';
			// asynch call
			let ps = Vue.$http.post(urls, body);
			Promise.all([ps]).then(([rs]) => {
				if ((rs.status === 200 || rs.status === 204)) {
          if (product ==='KH2') {rs.data['field5']=rs.data['field5'].replace(/[^\d.-]/g, '');rs.data['field6']=rs.data['field6'].replace(/[^\d.-]/g, ''); //去除非數字字元
                             Vue.KHdosing = Math.floor(rs.data['field5']/1000); Vue.Calday = Math.floor(rs.data['field5']%1000);
                             Vue.maxKHdosingPerHr = Math.floor(rs.data['field6']/10000); Vue.CalKH = rs.data['field6']%10000/1000;} // KH2: calibration solution KH value
          Vue.CalRemain = Math.round(rs.data['field12']); if (Vue.CalRemain < 0) {Vue.CalRemain =0;}
          Vue.mlspec = rs.data['field16'];
					console.log("KH-calsolution -- get parameters from server");
				}
			}, reason => {
				console.log('server error: ', reason);
				Vue.setMsg_logout(mlist[Vue.getLang()][14], 2);
      });
      
  }  // if user && user.sleep


}

export default {
  data: () => {
    return {
      disabled: false,
      title: "KH Setting",
      serial:"",
      KHdosing: 350,
      maxKHdosingPerHr: 35,
      Calday: 7,
      CalKH:7.5,
      //KHRemain: 1000,
      CalRemain:1000,
      //PairDev: "",
      mlspec:100,
      message: "",
      msglist: mlist,
      name: "",
      time_out:"",
      userS: localStorage.getItem('user')
    }
  },
  created: function () {
    // `this` points to the vm instance
	  //fetchData(this);
    //console.log('current KHdosing= ' + this.KHdosing + ', maxKHdosingPerHr=' + this.maxKHdosingPerHr);
  },
  destroyed: function () {
    //console.log('KH_cal_sloution destroy step');
    //clearInterval(this.pagedosing);
    clearTimeout(this.time_out);
  },
  computed: {
	  alertObject: function() {
        if (this.message) {
            return {"alert": true, "alert-info": true, "alert-warning":true, "alert-danger": false};  // alert-danger 紅色背景 alert-waring 黃色背景
        } else if (this.message.match('error')) {
            return {"alert": true, "alert-danger": true, "alert-info": false};
        } else {
            return {"alert": false, "alert-info": false, "alert-danger": false};
        }
    },
    user: () => {
      return this.$store.user
	  },
	  user1: function () {
		return this.$store.getters.user;
	  }

  },
  methods: {
  getLang: function () {
		  if (has(this.$route, "params.language")) {
			  return this.$route.params.language;
		  } else {
			  return mapLang();
		  }
  },
  
  setMsg: function (message, timer) {
        this.message = message;
        // set time in ms
        setTimeout( () => {
            this.message = "";
            this.enable();
        }, timer*1000);
    },
  setMsg_logout: function (message, timer) {  // show message for timer sec and logout
        this.message = message;
        // set time in ms
        setTimeout( () => {
            this.message = "";
            this.enable();
            ////// to complete logout and show login page need this 3 items
            this.$store.dispatch("setUser", {name: '', token: ''});
            this.$auth.destroyToken();
            this.$router.push({ name: 'entry', params: { language: this.$route.params.language } })
        }, timer*1000);
        
    },      
    apply: function () {
      //console.log("this: ", this.$http, startCfg, this.$store.user);
      this.disable();
      startCfg(this);
    },
    disable: function() { this.disabled = true; },
    enable: function() { this.disabled = false; },
	},
  mounted() {
    fetchData(this);
		
		//console.log('this.user.name=', this.user1.name);
		if (this.$auth.loggedIn()) {
			  this.time_out= setTimeout( () => {     // return to my-kh after 5 min
           this.$router.push({ name: 'my-kh', params: { language: this.$route.params.language } })
        }, 600*1000);
        //return this.fillData(1);
		} else {
      this.$auth.destroyToken();
			this.$router.push({ name: 'entry', params: { language: this.$route.params.language } })
		}
  }
  }


</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// KH_cal_solution.vue?1e0d7982